import { useQuery } from 'react-query';

import {
  SubscriberCouncilPartner,
  fetchSubscriberCouncilPartners,
} from '../utils/backend-api/partners';

export const SUBSCRIBER_COUNCIL_PARTNERS_KEY = 'SUBSCRIBER_COUNCIL_PARTNERS_KEY';

export default function usePartnersSubscriberCouncil() {
  const { data: scPartners, isLoading: isLoadingScPartners } = useQuery<SubscriberCouncilPartner[]>(
    SUBSCRIBER_COUNCIL_PARTNERS_KEY,
    async () => await fetchSubscriberCouncilPartners()
  );
  return { scPartners, isLoadingScPartners };
}
